import { COLORS } from "assets/styles/colors";
import { styled } from "styled-components";

export const ClientEvidenceContainer = styled.div`
  width: 100%;
  height: 90vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  svg {
    cursor: pointer;
  }

  .delete-modal {
    color: ${COLORS.red};
  }
`;

export const PaginatorWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-content: center;
  justify-content: center;
`;

export const Box = styled.div`
  &.flex-center {
    display: flex;
    justify-content: center;
    align-content: center;
    height: 100%;
    flex-wrap: wrap;
  }
`;

export const ClientEvidenceTitle = styled.div`
  font-size: 24px;
  color: ${COLORS.deepDark};
  margin: 10px;
`;

export const RemoveContainer = styled.div`
  svg {
    cursor: pointer;
    width: 15px;
    fill: ${COLORS.dimgrey};
  }
`;
